module.exports = __webpack_public_path__ + "img/cancun-bay-resort-2.0c9e7bf1.jpg";